<script setup lang="ts">
/**
 * Empty Layout
 * --------------------------------------------------------------------------------------------------
 * Layout used for splash pages
 */
</script>

<template>
    <div>
        <TheBaseLayout>
            <div class="relative h-full">
                <TheLogo />
                <NuxtPage />
            </div>
        </TheBaseLayout>
    </div>
</template>
